import { useFormContext } from 'react-hook-form'

import { FormImage } from '../../Form/FormImage/FormImage.js'
import { UploadableMedia } from '../../Form/FormImage/types.js'
import { T } from '../../i18n/index.js'

export const CoverImagePicker = () => {
  const { setValue } = useFormContext()

  const onImageChange = (image?: UploadableMedia) => {
    setValue('thumbnail', image ?? null, { shouldDirty: true })
  }

  return (
    <FormImage
      name="thumbnail"
      onChange={onImageChange}
      label={<T id="Event.Form.CoverImage" defaultMessage="Cover image" />}
    />
  )
}
